import { countries } from 'countries-list';

export const getCountryName = (countryCode: string): string => {
  const country = countries[countryCode as keyof typeof countries];
  return country?.name || countryCode;
};

export const getCountryCode = (countryName: string): string | null => {
  if (!countryName || countryName.toLowerCase() === 'unknown') {
    return null;
  }
  const countryEntry = Object.entries(countries).find(
    ([, country]) => country.name.toLowerCase() === countryName.toLowerCase(),
  );
  return countryEntry ? countryEntry[0] : null;
};
